<template>
  <div class="claim-record">
    <!-- 搜索 -->
    <div class="search">
      <el-form
        :model="exportForm"
        ref="exportForm"
        class="demo-ruleForm"
      >
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select
              class="white"
              v-model="exportForm.warehouseId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="责任归属：" prop="responsibleParty">
              <el-select
                class="white"
                v-model="exportForm.responsibleParty"
                placeholder="请选择责任归属"
              >
                <el-option
                  v-for="item in responsiblePartyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="date" label="日期：">
              <el-date-picker
                v-model="exportForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="快递公司：" prop="expressId">
            <el-select
              class="white"
              v-model="exportForm.expressId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">已确认表单</p>
      <div class="upload-return" @click="exportExcel">
        <span class="upload-return-img"></span>
        <span>导出</span>
      </div>
    </div>

    <!-- 已确认表达列表 -->
    <div class="table">
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        :row-class-name="tableRowClassName"
        :header-cell-class-name="headerCellClassName"
      >
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        >
        </el-table-column>
        <el-table-column
          label="照片"
          width="100"
        >
          <template slot-scope="scope">
            <div class="upload-img">
              <el-tooltip effect="dark" placement="top" content="查看照片">
                <img @click="lookImg(scope.row.images)" class="eye" src="~assets/images/eye.png">
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.isCancel"
              class="btn-red-text"
              type="text"
              @click="nullify(scope.row.id)"
            >作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="430px"
      class="look-img"
      title="查看图片"
      :destroy-on-close="true"
    >
      <el-carousel arrow="always" indicator-position="none" :autoplay="false" @change="changeCarousel">
        <el-carousel-item v-for="(item, index) in images" :key="index">
          <img v-if="!isNothingImg" class="img" :src="item">
          <div v-else class="nothing-container">
            <img class="nothimg-img" :src="item">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="indicator">
        <span class="indicator-high">
          {{ imgSort }}
        </span>/
        <span>
          {{ images.length }}
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Claim from "models/claim";
import warehouseMixins from "@/common/mixins/warehouse.js"
import expressMixins from "@/common/mixins/express.js"
import claimMixins from "@/common/mixins/claim.js"
import statusMixins from "@/common/mixins/status.js"
import PaginationTpl from "components/base/PaginationTpl";
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, expressMixins, statusMixins, claimMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        expressId: '',
        responsibleParty: '',
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '仓库', prop: 'warehouseName', width: '', salignment:'left'},
        {label: '时间', prop: 'billDate', width: '120', alignment:'left'},
        {label: '快递公司', prop: 'expressName', width: '120', alignment:'left'},
        {label: '操作人', prop: 'operator', width: '120', alignment:'left'},
        {label: '责任归属', prop: 'responsiblePartyVal', width: '120', alignment:'left'},
        {label: '问题分类', prop: 'logisticsProblemsTypeVal', width: '180', alignment:'left'},
        {label: '处理方案', prop: 'dealMethodVal', width: '120', alignment:'left'},
        {label: '订单号', prop: 'orderCode', width: '220', alignment:'left'},
        {label: '快递单号', prop: 'expressCode', width: '220', alignment:'left'},
        {label: '产品名称', prop: 'productName', width: '140', alignment:'left'},
        {label: '数量', prop: 'quantity', width: '150', alignment:'right'},
        {label: '申请金额', prop: 'involvedAmount', width: '150', alignment:'right'},
        {label: '确认金额', prop: 'payableAmount', width: '150', alignment:'right'},
        {label: '客户名称', prop: 'customerName', width: '120', alignment:'left'},
        {label: '项目名称', prop: 'projectName', width: '120', alignment:'left'},
        {label: '备注', prop: 'remarks', width: '150', alignment:'left'},
      ],
      
      loading: false,
      // 是否展示查看图片
      dialogVisible: false,
      // 图片序号
      imgSort: 1,
      images: [],
      // 是否展示缺省图
      isNothingImg: false,
    }
  },

  async created() {
    this.initWarehouse()
    this.initExpressList()
    await this.asyncInitProblemTypeList(1, true)
    this.initConfirmedecord()
  },

  methods: {
    /** 
     * @desc 已确认表单
    */
    initConfirmedecord() {
      let beginDate = this.exportForm.date[0]?this.exportForm.date[0]:''
      let endDate = this.exportForm.date[1]?this.exportForm.date[1]:''
      let data = {
        warehouseId: this.exportForm.warehouseId,
        beginDate,
        endDate,
        expressId: this.exportForm.expressId,
        responsibleParty: this.exportForm.responsibleParty,
        currentPage: this.currentPage
      }
      Claim.getConfirmRecordList(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.billDate = i.billDate
            obj.expressId = i.expressId
            obj.expressName = i.expressName
            obj.operator = i.operator
            obj.logisticsProblemsType = i.logisticsProblemsType
            this.logisticsProblemTypeList.map(v => {
              if (i.logisticsProblemsType == v.id) {
                obj.logisticsProblemsTypeVal = v.name
              }
            })
            obj.dealMethod = i.dealMethod
            obj.dealMethodVal = this.DEAL_METHOD[i.dealMethod]
            obj.orderCode = i.orderCode
            obj.expressCode = i.expressCode
            obj.productName = i.productName
            obj.quantity = i.quantity
            obj.involvedAmount = numsToRMBSymbolAndMillimeter(i.involvedAmount)
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.images = i.imageList
            obj.responsibleParty = i.responsibleParty
            obj.responsiblePartyVal = this.RESPONSIBLE_PARTY[i.responsibleParty]
            obj.payableAmount = numsToRMBSymbolAndMillimeter(i.payableAmount)
            obj.carrierBearAmount = i.carrierBearAmount
            obj.approvalRemarks = i.approvalRemarks
            obj.remarks = i.remarks
            obj.isCancel = i.isCancel
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 
      获取问题分类 
      type: true获取所有问题分类数据 false获取当前认责方的问题分类数据
    */
    async asyncInitProblemTypeList(responsibleType, type) {
      let res = await Claim.postProblemTypeList(responsibleType)
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.text
          arr.push(obj)
        })
        if (type) {
          if (responsibleType == 1) {
            await this.asyncInitProblemTypeList(2, true)
          }
          this.logisticsProblemTypeList = this.logisticsProblemTypeList.concat(arr);
        }
      } else {
        this.$message.error(res.message)
      }
    },
    
    searchData() {
      this.currentPage = 1;
      this.initConfirmedecord();
    },
    
    reset() {
      this.exportForm.date = ""
      this.exportForm.expressId = ""
      this.exportForm.warehouseId = ""
      this.exportForm.responsibleParty = ""
    },
    
    /** 
     * @desc 导出Excel表格
    */
    exportExcel() {
      let beginDate = this.exportForm.date[0]?this.exportForm.date[0]:''
      let endDate = this.exportForm.date[1]?this.exportForm.date[1]:''
      let options = {
        warehouseId: this.exportForm.warehouseId,
        beginDate,
        endDate,
        expressId: this.exportForm.expressId,
        responsibleParty: this.exportForm.responsibleParty,
      }
      Claim.getGoodsPriceExcel(options).then((res) => {
        downLoadFileByBlob(res)
      });
    },

    /** 
     * @desc 作废
    */
    nullify(id) {
      this.$confirm("作废后，该确认索赔单将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          claimId: id
        }
        Claim.postNullifyClaimList(data).then(res => {
          if (res.success) {
            this.$message.success('作废成功')
            this.initConfirmedecord()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    /** 
     * @desc 为 Table 中的某一行添加 class
    */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 9 && columnIndex < 13) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initConfirmedecord();
    },

    /** 
     * @desc 查看图片
    */
    lookImg(v) {
      this.imgSort = 1
      this.dialogVisible = true
      if (v.length > 0) {
        this.images = v
        this.isNothingImg = false
      } else {
        let img = require('../../../../assets/images/nothing/nothing.png')
        this.images = [img]
        this.isNothingImg = true
      }
    },

    /** 
     * @desc 获取轮播图序号
    */
    changeCarousel(v) {
      this.imgSort = v+1
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/claim-record.scss";
</style>